import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { OneTimePayFeatureEffects } from './one-time-pay-feature.effects';
import * as fromOneTimePayState from './one-time-pay-feature.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(fromOneTimePayState.oneTimePayFeatureKey, fromOneTimePayState.reducer),
    EffectsModule.forFeature([OneTimePayFeatureEffects])
  ]
})
export class OneTimePayStateModule {}
